import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function NonAutorise(): React.ReactElement {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="403"
      subTitle="Vous n'avez pas la permission d'accéder à cette page."
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          Retour à l'accueil
        </Button>
      }
    />
  );
}
